<template>
    <div>
        <b-breadcrumb v-if="breadcrumb" Crumbs="breadcrumb" />
        <h1>{{ title }}</h1>
        <hr />
        <div class="container">
        <article>
            Lorem ipsum dolor sit amet,
            consectetur adipiscing elit.
            Integer gravida venenatis tortor,
            sit amet volutpat ligula consectetur vel.
            Phasellus lacinia orci in odio egestas rutrum.
            Aenean sollicitudin massa et efficitur faucibus.
            Suspendisse potenti. Etiam vel ligula quam.
            Orci varius natoque penatibus et magnis dis parturient montes,
            nascetur ridiculus mus. Vestibulum eros erat,
            sollicitudin vitae mauris eget, pellentesque faucibus dui.
            Nullam fringilla arcu vel dolor faucibus pellentesque.
        </article>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
class HeaderText extends Vue {
    @Prop({ type: String, required: true })
    title;

    @Prop({ type: Array, required: false })
    breadcrumb;
}

export default HeaderText;
</script>

<style>

</style>
